import * as authentication from '@cascade/react/authentication';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import type { TDemoGateProps } from './DemoGate.types.ts';
import { useRequestedUrl } from '#hooks/use-requested-url/index.ts';

export const DemoGate = ({
  loading,
  unauthenticated,
  homePath,
}: TDemoGateProps) => {
  const { isAuthenticated, isDemo, canStartSignIn, signInAsDemo, signOut } =
    authentication.useAuthentication();

  const { forgetRequestedUrl } = useRequestedUrl();

  useEffect(() => {
    if (!isAuthenticated || isDemo) {
      return;
    }

    signOut();
  }, [isAuthenticated, isDemo, signOut]);

  useEffect(() => {
    if (!canStartSignIn) {
      return;
    }

    forgetRequestedUrl();
    signInAsDemo().catch(() => undefined);
  }, [canStartSignIn, forgetRequestedUrl, signInAsDemo]);

  return (
    <authentication.AuthenticationGate
      loading={loading}
      unauthenticated={unauthenticated}
    >
      {isDemo ? <Navigate to={homePath} replace /> : loading}
    </authentication.AuthenticationGate>
  );
};
